import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const AXIS_SUBMIT_AND_EXIT_FOLLOW_UP_MESSAGE =
  'Continue entering information to speed things up, or choose “Submit and Exit Application” to have a broker reach out';

export const AXIS_CONTINUE_APPLICATION_FOLLOW_UP_MESSAGE =
  'Continue application on the following page or submit now and hear from a broker.';

interface AxisSubmitAndExitFollowUpTextProps {
  centred?: boolean;
  message?: string;
}

export const AxisSubmitAndExitFollowUpText = ({
  centred = false,
  message = AXIS_SUBMIT_AND_EXIT_FOLLOW_UP_MESSAGE,
}: AxisSubmitAndExitFollowUpTextProps) => {
  return <FollowUpText centred={centred}>{message}</FollowUpText>;
};

const FollowUpText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'centred',
})<{ centred?: boolean }>(({ theme, centred }) => ({
  ...theme.typography.body1,
  color: theme.palette.text.secondary,
  whiteSpace: 'pre-line',
  ...(centred
    ? {
        textAlign: 'center',
        width: '100%',
      }
    : {}),
}));
